import { useQuery } from '@tanstack/react-query';
import { get } from '../../api/client';

export const useGetStudent = ({ studentId }: { studentId: number }) =>
  useQuery([studentId], () => get({ url: `api/v1/students/${studentId}` }));
